import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"


export default /*@__PURE__*/_defineComponent({
  __name: 'Badge',
  props: {
    type: { default: 'default' },
    size: { default: 'normal' }
  },
  setup(__props: any) {

// Props with defaults


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(`badge badge-${_ctx.type} badge-${_ctx.size} `)
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 2))
}
}

})